(function() {
  function getTarget(target, selector) {
    if (!target || !target.closest) return null;
    return target.closest(selector);
  }

  function setAttr(el, name, value) {
    if (!el) return;
    if (value === null || typeof value === 'undefined') {
      el.removeAttribute(name);
      return;
    }
    el.setAttribute(name, value);
  }

  function setDisabledState(cta, isAvailable) {
    if (!cta) return;

    cta.classList.toggle('is-disabled', !isAvailable);
    setAttr(cta, 'aria-disabled', isAvailable ? null : 'true');

    if ('disabled' in cta) {
      cta.disabled = !isAvailable;
    }
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function openCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('wubs:cart-open'));
    } catch (e) {}
  }

  function updateLinks(card, url) {
    if (!url) return;

    card.querySelectorAll('[data-wubs-prod-card-url]').forEach(function(el) {
      if (el.matches('a')) {
        el.href = url;
      }

      el.setAttribute('data-product-url', url);
    });
  }

  function updateImage(card, swatch) {
    var image = card.querySelector('.wubs-produkt-kort__image--primary');
    var src = swatch.getAttribute('data-variant-image-src');
    var srcset = swatch.getAttribute('data-variant-image-srcset');

    if (!image || !src) return;

    image.src = src;

    if (srcset) {
      image.srcset = srcset;
    } else {
      image.removeAttribute('srcset');
    }
  }

  function updateDiscount(card, swatch) {
    var badge = card.querySelector('[data-wubs-prod-card-discount]');
    if (!badge) return;

    var isOnSale = swatch.getAttribute('data-variant-on-sale') === 'true';
    var percent = parseInt(swatch.getAttribute('data-variant-discount-percent') || '0', 10);

    if (isOnSale && percent > 0) {
      badge.textContent = '-' + percent + '%';
      badge.classList.remove('is-hidden');
      badge.removeAttribute('aria-hidden');
      return;
    }

    badge.classList.add('is-hidden');
    badge.setAttribute('aria-hidden', 'true');
  }

  function updateMeta(card, swatch) {
    var meta = card.querySelector('[data-wubs-prod-card-meta]');
    if (!meta) return;

    var value = swatch.getAttribute('data-variant-meta') || '';
    meta.textContent = value;
    meta.hidden = value.length === 0;
  }

  function updateCta(card, swatch) {
    var cta = card.querySelector('[data-wubs-prod-card-cta]');
    if (!cta) return;

    var variantId = swatch.getAttribute('data-variant-id') || '';
    var url = swatch.getAttribute('data-variant-url') || cta.getAttribute('data-product-url') || '';
    var price = swatch.getAttribute('data-variant-price') || '';
    var isAvailable = swatch.getAttribute('data-variant-available') === 'true';
    var labelText = isAvailable
      ? (cta.getAttribute('data-cta-label') || '')
      : (cta.getAttribute('data-soldout-label') || '');
    var label = cta.querySelector('[data-wubs-prod-card-label]');
    var priceEl = cta.querySelector('[data-wubs-prod-card-price]');

    setAttr(cta, 'data-variant-id', variantId);
    setAttr(cta, 'data-product-url', url);
    setAttr(cta, 'data-available', isAvailable ? 'true' : 'false');

    if (cta.matches('a') && url) {
      cta.href = url;
    }

    if (label && labelText) {
      label.textContent = labelText;
      cta.setAttribute('aria-label', labelText);
    }

    if (priceEl && price) {
      priceEl.textContent = price;
    }

    setDisabledState(cta, isAvailable);
  }

  function updateActiveSwatches(card, activeSwatch) {
    card.querySelectorAll('[data-wubs-prod-card-variant]').forEach(function(swatch) {
      var isActive = swatch === activeSwatch;
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function handleVariantClick(event) {
    var swatch = getTarget(event.target, '[data-wubs-prod-card-variant]');
    if (!swatch) return;

    var card = swatch.closest('[data-wubs-prod-card]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    var url = swatch.getAttribute('data-variant-url') || '';

    updateActiveSwatches(card, swatch);
    updateLinks(card, url);
    updateImage(card, swatch);
    updateMeta(card, swatch);
    updateDiscount(card, swatch);
    updateCta(card, swatch);
  }

  if (!window.__wubsProductCardVariantInit) {
    window.__wubsProductCardVariantInit = true;
    document.addEventListener('click', handleVariantClick);
  }

  if (!window.__wubsProductCardAtcInit) {
    window.__wubsProductCardAtcInit = true;

    document.addEventListener('click', function(event) {
      var btn = getTarget(event.target, '[data-wubs-prod-card-atc]');
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-loading')) return;

      var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
      var productUrl = btn.getAttribute('data-product-url') || '';

      if (!variantId) {
        if (productUrl) window.location.href = productUrl;
        return;
      }

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function(res) {
          if (!res.ok) {
            return res.json().then(function(err) {
              throw err;
            });
          }

          return res.json();
        })
        .then(function() {
          openCartDrawer();
        })
        .catch(function() {
          if (productUrl) window.location.href = productUrl;
        })
        .finally(function() {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  if (!window.__wubsQuickBuyInit) {
    window.__wubsQuickBuyInit = true;

    var state = {
      product: null,
      selectedVariant: null,
      selectedOptions: [],
      lastTrigger: null
    };

    var modal = null;
    var closeTimer = null;

    function modalEl(selector) {
      if (!modal) modal = document.querySelector('[data-wubs-quick-buy]');
      return modal ? modal.querySelector(selector) : null;
    }

    function normalizeOptions(variant) {
      if (!variant) return [];
      if (Array.isArray(variant.options)) return variant.options.slice();

      return [variant.option1, variant.option2, variant.option3].filter(function(option) {
        return option !== null && typeof option !== 'undefined' && String(option).length;
      });
    }

    function normalizeProduct(product) {
      product = product || {};
      product.options = Array.isArray(product.options) ? product.options : [];
      product.variants = Array.isArray(product.variants) ? product.variants : [];

      product.variants.forEach(function(variant) {
        variant.id = Number(variant.id || 0);
        variant.price = Number(variant.price || 0);
        variant.compare_at_price = Number(variant.compare_at_price || 0);
        variant.available = variant.available === true || variant.available === 'true';
        variant.options = normalizeOptions(variant);
      });

      return product;
    }

    function productFromCard(card) {
      var script = card ? card.querySelector('[data-wubs-prod-json]') : null;
      if (!script) return null;

      try {
        return normalizeProduct(JSON.parse(script.textContent || '{}'));
      } catch (e) {
        return null;
      }
    }

    function findVariantById(product, id) {
      id = Number(id || 0);
      if (!product || !id) return null;

      return product.variants.find(function(variant) {
        return Number(variant.id) === id;
      }) || null;
    }

    function findFirstAvailableVariant(product) {
      if (!product || !product.variants.length) return null;

      return product.variants.find(function(variant) {
        return variant.available;
      }) || product.variants[0] || null;
    }

    function variantMatchesOptions(variant, options) {
      var variantOptions = normalizeOptions(variant);
      return options.every(function(value, index) {
        return typeof value === 'undefined' || value === null || String(variantOptions[index] || '') === String(value);
      });
    }

    function findVariantByOptions(product, options, availableOnly) {
      if (!product || !product.variants.length) return null;

      return product.variants.find(function(variant) {
        if (availableOnly && !variant.available) return false;
        return variantMatchesOptions(variant, options);
      }) || null;
    }

    function findVariantForOption(product, optionIndex, value, availableOnly) {
      if (!product || !product.variants.length) return null;

      return product.variants.find(function(variant) {
        var options = normalizeOptions(variant);
        if (availableOnly && !variant.available) return false;
        return String(options[optionIndex] || '') === String(value);
      }) || null;
    }

    function cleanMoney(value) {
      return String(value || '')
        .replace(/([0-9])([,.])00(\s*(?:kr|sek|dkk|nok|eur|usd|€|\$|£)?)(?=\s|<|$)/gi, '$1$3')
        .replace(/\bSEK\b/g, 'kr');
    }

    function formatMoney(cents) {
      var value = (Number(cents) || 0) / 100;
      var currency = 'SEK';

      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          currency = window.Shopify.currency.active;
        }
      } catch (e) {}

      try {
        var hasDecimals = Math.abs(value - Math.round(value)) > 0.0001;
        return cleanMoney(new Intl.NumberFormat('sv-SE', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: hasDecimals ? 2 : 0
        }).format(value));
      } catch (e) {
        return cleanMoney(value.toFixed(2) + ' kr');
      }
    }

    function setSelectedVariant(variant) {
      state.selectedVariant = variant || null;
      state.selectedOptions = normalizeOptions(variant);
    }

    function optionValueAvailable(product, optionIndex, value) {
      return !!findVariantForOption(product, optionIndex, value, true);
    }

    function imageForSelection(product, variant) {
      return (variant && variant.image) || product.featured_image || '';
    }

    function introForProduct(product) {
      var description = String(product.description || '').trim();
      if (description) return description;
      if (product.type) return 'Välj variant och lägg till ' + product.type.toLowerCase() + ' direkt i varukorgen.';
      return 'Välj variant och lägg produkten direkt i varukorgen.';
    }

    function renderOptions() {
      var product = state.product;
      var wrap = modalEl('[data-wubs-quick-buy-options]');
      if (!wrap || !product) return;

      wrap.innerHTML = '';

      if (product.has_only_default_variant || product.variants.length <= 1 || !product.options.length) {
        wrap.hidden = true;
        return;
      }

      wrap.hidden = false;

      product.options.forEach(function(option, optionIndex) {
        if (!option || !Array.isArray(option.values) || !option.values.length) return;

        var group = document.createElement('div');
        group.className = 'wubs-quick-buy__option';

        var label = document.createElement('span');
        label.className = 'wubs-quick-buy__option-name';
        label.textContent = option.name || ('Alternativ ' + (optionIndex + 1));
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'wubs-quick-buy__values';

        option.values.forEach(function(value) {
          var valueText = String(value || '');
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'wubs-quick-buy__value';
          button.textContent = valueText;
          button.setAttribute('data-wubs-quick-buy-option', String(optionIndex));
          button.setAttribute('data-wubs-quick-buy-value', valueText);

          if (String(state.selectedOptions[optionIndex] || '') === valueText) {
            button.classList.add('is-active');
            button.setAttribute('aria-pressed', 'true');
          } else {
            button.setAttribute('aria-pressed', 'false');
          }

          if (!optionValueAvailable(product, optionIndex, valueText)) {
            button.disabled = true;
          }

          values.appendChild(button);
        });

        group.appendChild(values);
        wrap.appendChild(group);
      });
    }

    function renderQuickBuy() {
      var product = state.product;
      var variant = state.selectedVariant;
      if (!modal || !product) return;

      var titleEl = modalEl('[data-wubs-quick-buy-title]');
      var priceEl = modalEl('[data-wubs-quick-buy-price]');
      var introEl = modalEl('[data-wubs-quick-buy-intro]');
      var imageEl = modalEl('[data-wubs-quick-buy-image]');
      var linkEl = modalEl('[data-wubs-quick-buy-link]');
      var addEl = modalEl('[data-wubs-quick-buy-add]');
      var messageEl = modalEl('[data-wubs-quick-buy-message]');
      var image = imageForSelection(product, variant);

      if (titleEl) titleEl.textContent = product.title || '';
      if (priceEl) priceEl.textContent = variant ? formatMoney(variant.price) : '';
      if (introEl) introEl.textContent = introForProduct(product);

      if (imageEl) {
        if (image) {
          imageEl.src = image;
          imageEl.alt = product.title || '';
          imageEl.hidden = false;
        } else {
          imageEl.removeAttribute('src');
          imageEl.alt = '';
          imageEl.hidden = true;
        }
      }

      if (linkEl) {
        linkEl.href = product.url || '#';
      }

      if (messageEl) {
        messageEl.textContent = '';
      }

      if (addEl) {
        var available = !!(variant && variant.available);
        addEl.disabled = !available;
        addEl.setAttribute('data-variant-id', variant ? String(variant.id) : '');
        addEl.textContent = available ? 'Köp nu' : 'Slutsåld';
      }

      renderOptions();
    }

    function selectOption(optionIndex, value) {
      var product = state.product;
      if (!product) return;

      var nextOptions = state.selectedOptions.slice();
      nextOptions[optionIndex] = value;

      var nextVariant = findVariantByOptions(product, nextOptions, false);
      if (!nextVariant) {
        nextVariant = findVariantForOption(product, optionIndex, value, true) || findVariantForOption(product, optionIndex, value, false);
      }

      if (nextVariant) {
        setSelectedVariant(nextVariant);
      } else {
        state.selectedOptions = nextOptions;
        state.selectedVariant = null;
      }

      renderQuickBuy();
    }

    function openQuickBuy(trigger) {
      var card = trigger ? trigger.closest('[data-wubs-prod-card]') : null;
      var product = productFromCard(card);
      if (!product) return false;

      if (!modal) modal = document.querySelector('[data-wubs-quick-buy]');
      if (!modal) return false;

      clearTimeout(closeTimer);

      var requestedVariant = findVariantById(product, trigger.getAttribute('data-variant-id'));
      state.product = product;
      state.lastTrigger = trigger;
      setSelectedVariant(requestedVariant || findFirstAvailableVariant(product));
      renderQuickBuy();

      modal.hidden = false;
      modal.removeAttribute('hidden');
      document.documentElement.classList.add('wubs-quick-buy-open');
      document.body.classList.add('wubs-quick-buy-open');

      requestAnimationFrame(function() {
        modal.classList.add('is-open');
      });

      var focusTarget = modalEl('[data-wubs-quick-buy-add]') || modalEl('[data-wubs-quick-buy-close]');
      if (focusTarget && focusTarget.focus) {
        setTimeout(function() {
          focusTarget.focus();
        }, 30);
      }

      return true;
    }

    function closeQuickBuy() {
      if (!modal || modal.hidden) return;

      modal.classList.remove('is-open');
      document.documentElement.classList.remove('wubs-quick-buy-open');
      document.body.classList.remove('wubs-quick-buy-open');

      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        if (!modal.classList.contains('is-open')) {
          modal.hidden = true;
          modal.setAttribute('hidden', '');
        }
      }, 190);

      if (state.lastTrigger && state.lastTrigger.focus) {
        try {
          state.lastTrigger.focus();
        } catch (e) {}
      }
    }

    function addSelectedVariant(button) {
      var variant = state.selectedVariant;
      var product = state.product;
      var messageEl = modalEl('[data-wubs-quick-buy-message]');

      if (!variant || !variant.available) {
        if (messageEl) messageEl.textContent = 'Välj en tillgänglig variant.';
        return;
      }

      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Lägger till...';

      if (messageEl) messageEl.textContent = '';

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variant.id,
          quantity: 1
        })
      })
        .then(function(res) {
          if (!res.ok) {
            return res.json().then(function(err) {
              throw err;
            });
          }

          return res.json();
        })
        .then(function() {
          closeQuickBuy();
          openCartDrawer();
        })
        .catch(function(err) {
          if (messageEl) {
            messageEl.textContent = (err && err.description) ? err.description : 'Kunde inte lägga till produkten. Försök igen.';
          } else if (product && product.url) {
            window.location.href = product.url;
          }
        })
        .finally(function() {
          button.classList.remove('is-loading');
          renderQuickBuy();
        });
    }

    document.addEventListener('click', function(event) {
      var quickTrigger = getTarget(event.target, '[data-wubs-prod-card-quick]');
      if (quickTrigger) {
        event.preventDefault();
        event.stopPropagation();

        if (quickTrigger.disabled || quickTrigger.getAttribute('aria-disabled') === 'true') return;
        if (!openQuickBuy(quickTrigger)) {
          var url = quickTrigger.getAttribute('data-product-url') || '';
          if (url) window.location.href = url;
        }
        return;
      }

      var closeTrigger = getTarget(event.target, '[data-wubs-quick-buy-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeQuickBuy();
        return;
      }

      var optionTrigger = getTarget(event.target, '[data-wubs-quick-buy-option]');
      if (optionTrigger) {
        event.preventDefault();
        if (optionTrigger.disabled) return;
        selectOption(Number(optionTrigger.getAttribute('data-wubs-quick-buy-option') || 0), optionTrigger.getAttribute('data-wubs-quick-buy-value') || '');
        return;
      }

      var addTrigger = getTarget(event.target, '[data-wubs-quick-buy-add]');
      if (addTrigger) {
        event.preventDefault();
        if (addTrigger.disabled || addTrigger.classList.contains('is-loading')) return;
        addSelectedVariant(addTrigger);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeQuickBuy();
      }
    });
  }
})();
